import React, { useEffect, useState } from "react";
import { Button, Text } from "components";
import Modal from "react-modal";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import axios from "axios";
import { useFormik } from "formik";
import * as Yup from "yup";
import Select from "react-select";

const DeliveryChallanItemJobWork = () => {
  const [visible, setvisible] = useState(true);
  const [checkedQuantities, setCheckedQuantities] = useState([]);
  const [remaingItems, setRemainingItems] = useState([]);

  const [searchTerm, setSearchTerm] = useState("");
  const [selectAllChecked, setSelectAllChecked] = useState(false);
  let navigate = useNavigate();
  const { id } = useParams();
  const { delivery_challan_type_id } = useParams();
  const { customer_id } = useParams();
  const token = sessionStorage.getItem("token");
  const headers = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };
  const [erplist, setErplist] = useState([]);
  useEffect(() => {
    const storedErplist = sessionStorage.getItem("erplist");

    if (storedErplist) {
      try {
        const parsedErplist = JSON.parse(storedErplist);
        setErplist(parsedErplist);
      } catch (error) {
        console.error("Error parsing JSON:", error);
      }
    }
  }, []);

  //   const validationSchema = Yup.object().shape({

  //   });
  const formik = useFormik({
    initialValues: {
      item_detail_id: "",

      company_warehouse_id: "",
      company_purchase_order_entry_id:
        checkedQuantities[0]?.company_purchase_order_id,
      quantity: "",
      po_wo_inv_other_id: "",
      po_wo_inv_other_detail: "",
      description: "NA",
      supplier_id: "",
      supplier_invoice: "",
      company_purchase_order_id: "",
    },
    // validationSchema: validationSchema,
    onSubmit: (values) => {
      handleFormSubmit(values);
    },
  });

  console.log(formik.values.company_purchase_order_id);

  const requestPayload = {
    company_purchase_order_id: 0,
    offset: 0,
    limit: 0,
    search_company_specific_criteria_id: 0,
    search_company_specific_date_range_id: 0,
    search_parameter: "",
  };

  useEffect(() => {
    CompanyPurchasechecked();
  }, [Number(id)]);

  const chech_obj = {
    delivery_challan_id: Number(id),
  };

  const CompanyPurchasechecked = () => {
    console.log(chech_obj, "check");
    axios
      .post(
        "/api/purple-fusion/delivarychallanitem/get/jobwork",
        chech_obj,
        headers
      )
      .then((response) => {
        const itemsWithChecked = response.data.map((item, index) => ({
          ...item,
          id: item.id || index, // fallback unique id if API doesn’t provide
          checked: false,
          quantity_accepted: item.quantity_accepted?.toString() || "",
          remainingQuantity:
            item.quantity_accepted -
            item.quantity_in_all_delivery_challan_for_company_purchase_order,
          item_description: item.item_description || "",
        }));
        setCheckedQuantities(itemsWithChecked);

        // setCheckedQuantities(itemsWithChecked);
        console.log(response.data);
      })
      .catch((err) => {
        console.log(err);
      });
  };
  // console.log(checkedQuantities);

  const handleToggle = (itemId) => {
    setCheckedQuantities((prevItems) => {
      const updatedItems = prevItems.map((item) =>
        item.id === itemId ? { ...item, checked: !item.checked } : item
      );

      const allChecked = updatedItems.every((item) => item.checked);
      setSelectAllChecked(allChecked);

      return updatedItems;
    });
  };

  const handleSelectAll = () => {
    setCheckedQuantities((prevItems) => {
      const allChecked = !selectAllChecked;

      return prevItems.map((item) => ({
        ...item,
        checked:
          searchTerm === "" ||
          item.itemname.toLowerCase().includes(searchTerm.toLowerCase())
            ? allChecked
            : item.checked,
      }));
    });

    setSelectAllChecked(!selectAllChecked);
  };

  const handleFormSubmit = () => {
    const newArray = checkedQuantities
      .filter((item) => item.checked === true)
      .map((item) => ({
        item_detail_id: item.item_detail_id,
        delivery_challan_id: id,
        quantity: item.quantity_accepted,
      }));
    console.log(newArray);
    if (newArray.length === 0) {
      toast.error("Atleast select one item", {
        autoClose: 2000,
      });
    } else {
      axios
        .post(
          "/api/purple-fusion/delivarychallanitem/create/jobwork",
          newArray,
          headers
        )
        .then((response) => {
          console.log(response.data);
          const message = response.data.message;
          response.data.status
            ? toast.success(message, {
                autoClose: 2000,
                onClose: () => {
                  setvisible(false);
                  navigate(
                    `/delivarychallanitem/list/${id}/${delivery_challan_type_id}/${customer_id}`
                  );
                },
              })
            : toast.error(message, {
                autoClose: 2000,
              });
        })
        .catch((error) => {
          console.log(error);
          setvisible(false);
          navigate("*");
        });
    }
  };

  const handleQuantityChange = (id, value) => {
    setCheckedQuantities((prev) =>
      prev.map((item) =>
        item.id === id
          ? { ...item, quantity_accepted: value } // keep raw string
          : item
      )
    );
  };

  const handleDescriptionChange = (itemId, value) => {
    setCheckedQuantities((prevItems) =>
      prevItems.map((item) =>
        item.id === itemId ? { ...item, description: value } : item
      )
    );
  };

  const customStyle = {
    content: {
      width: "90%",
      hieght: "80%",
      margin: "auto",
    },
    overlay: { backgroundColor: "rgba(0, 0, 0, 0.5)" },
  };

  return (
    <div>
      {erplist.some((item) => item.erp_module_id === 51 && item.add) ? (
        <div>
          <Modal
            isOpen={visible}
            style={customStyle}
            onRequestClose={() => {
              // setvisible(false);
              // navigate(`/stocktransaction/purchaselist`);
            }}
          >
            <form onSubmit={formik.handleSubmit}>
              <div className="bg-white-A700 flex flex-col font-inter items-center justify-start mx-auto w-full">
                <div className="flex md:flex-col flex-row md:gap-5 items-start justify-evenly w-full">
                  <div className="flex flex-1 flex-col gap-[19px] justify-start md:px-5 w-full">
                    <div>
                      <div className="flex flex-row items-center justify-start ">
                        <div className="flex flex-row  items-start justify-between w-full ">
                          <Text
                            className="mt-[5px] md:text-xl sm:text-[24px] text-base text-black-900 tracking-[0.20px]"
                            size="txtInterMedium24"
                          >
                            Add Job Work Item to Delivery Challan
                          </Text>
                        </div>
                        <div className="flex flex-row items-center justify-end ml-auto top-2 ">
                          <Button
                            className="cursor-pointer font-medium mb-1.5 min-w-[70px] rounded-[7px] text-center text-xl tracking-[0.20px] active:scale-90 transition-transform duration-200"
                            shape="round"
                            color="blue_A700"
                            size="base"
                            variant="fill"
                            type="submit"
                          >
                            Save
                          </Button>
                          <Button
                            className="cursor-pointer font-medium mb-3 min-w-[70px] rounded-[7px] text-center text-xl tracking-[0.20px] "
                            shape="round"
                            color="white"
                            size="base"
                            variant="fill"
                            se
                            onClick={() => {
                              setvisible(false);
                              navigate(
                                `/delivarychallanitem/list/${id}/${delivery_challan_type_id}/${customer_id}`
                              );
                            }}
                          >
                            ╳
                          </Button>
                        </div>
                      </div>
                      <ToastContainer />
                    </div>
                    <div className="flex flex-col items-center justify-start mt-4 w-full ">
                      <div className="md:gap-5 gap-x-[75px] gap-y-[25px] grid md:grid-cols-1 grid-cols-2 justify-center min-h-[auto] w-full mt-0">
                        <div className="flex">
                          <input
                            type="text"
                            placeholder="Search..."
                            className="bg-white-A700 border border-gray-400_02 border-solid  h-9 rounded-[5px] mb-0 w-full"
                            value={searchTerm}
                            onChange={(e) => {
                              setSearchTerm(e.target.value);
                              setSelectAllChecked(
                                checkedQuantities
                                  .filter(
                                    (item) =>
                                      item.itemname
                                        .toLowerCase()
                                        .includes(searchTerm.toLowerCase()) ||
                                      item.itemname
                                        .toLowerCase()
                                        .includes(searchTerm.toLowerCase())
                                  )
                                  .filter((item) => item.checked === true)
                                  .length === checkedQuantities.length
                                  ? true
                                  : false
                              );
                            }}
                          />
                        </div>
                      </div>
                    </div>
                    <div className="flex flex-col items-center justify-start mt-0 w-full">
                      <div className="md:gap-5 gap-[50px] grid md:grid-cols-1 grid-cols-1 justify-center min-h-[auto] w-full">
                        <div className="flex flex-1 flex-col gap-1 items-start justify-start w-full overflow-auto min-h-[400px]">
                          <table className="min-w-full font-inter whitespace-nowrap text-gray-800 text-sm text-left dark:text-gray-400">
                            <thead className="text-sm w-full border-2 text-gray-800 uppercase bg-gray-50 dark:bg-gray-700 dark:text-gray-400">
                              <tr className="bg-gray-200">
                                <th className="px-6 py-4">
                                  <label>
                                    <input
                                      type="checkbox"
                                      onClick={handleSelectAll}
                                      className="rounded-[5px]"
                                      checked={selectAllChecked}
                                    />
                                    {"   "} All
                                  </label>
                                </th>
                                <th className="px-6 py-4">ITEM NAME</th>
                                <th className="px-6 py-4">QUANTITY</th>
                                <th className="px-6 py-4">REMAINING QTY</th>
                                <th>AVAILABLE QUANTITY</th>
                                <th className="px-6 py-4">COST PRICE</th>
                                <th className="px-6 py-4">ITEM AMOUNT</th>
                                <th className="px-6 py-4">
                                  TOTAL TAXABLE AMOUNT
                                </th>
                                <th className="px-6 py-4">HSN CODE</th>
                                <th className="px-6 py-4">SAC CODE</th>
                                <th className="px-6 py-4">SGST%</th>
                                <th className="px-6 py-4">CGST%</th>
                                <th className="px-6 py-4">IGST%</th>
                                <th className="px-6 py-4">SGST AMOUNT</th>
                                <th className="px-6 py-4">CGST AMOUNT</th>
                                <th className="px-6 py-4">IGST AMOUNT</th>
                                <th className="px-6 py-4">TOTAL TAX</th>
                                <th className="px-6 py-4">DESCRIPTION</th>
                              </tr>
                            </thead>

                            <tbody className="text-gray-800 border-2">
                              {checkedQuantities
                                .filter((item) =>
                                  (item.itemname ?? "")
                                    .toLowerCase()
                                    .includes(searchTerm.toLowerCase())
                                )
                                .map((item) => {
                                  // convert safely
                                  const qty =
                                    parseFloat(item.quantity_accepted) || 0;
                                  const itemAmount = qty * item.cost_price;
                                  const taxableAmount = itemAmount;
                                  const sgstAmount =
                                    Math.round(
                                      ((qty *
                                        (item.sgst_percentage *
                                          item.cost_price)) /
                                        100) *
                                        1000
                                    ) / 1000;

                                  const cgstAmount =
                                    Math.round(
                                      ((qty *
                                        (item.cgst_percentage *
                                          item.cost_price)) /
                                        100) *
                                        1000
                                    ) / 1000;

                                  const igstAmount =
                                    Math.round(
                                      ((qty *
                                        (item.igst_percentage *
                                          item.cost_price)) /
                                        100) *
                                        1000
                                    ) / 1000;

                                  const totalTax =
                                    Math.round(
                                      (sgstAmount + cgstAmount + igstAmount) *
                                        1000
                                    ) / 1000;
                                    const isExceeding = qty > item.remainingQuantity;

                                  return (
                                    <tr key={item.id}>
                                      <td className="px-6 py-4">
                                        <input
                                          className="rounded-[5px]"
                                          type="checkbox"
                                          id={`item-${item.id}`}
                                          checked={item.checked}
                                          onChange={() => handleToggle(item.id)}
                                        />
                                      </td>

                                      <td className="px-6 py-4">
                                        {item.itemname}
                                      </td>

                                      {/* <td className="px-6 py-6">
                                        <input
                                          type="text"
                                          value={item.quantity_accepted}
                                          onChange={(e) =>
                                            handleQuantityChange(
                                              item.id,
                                              e.target.value
                                            )
                                          }
                                          disabled={!item.checked}
                                          className="border border-gray-400 rounded px-2 py-1 w-20"
                                        />
                                      </td> */}
                                      <td className="px-6 py-6">
                                        <input
                                          type="number"
                                          value={item.quantity_accepted}
                                          onChange={(e) =>
                                            handleQuantityChange(
                                              item.id,
                                              e.target.value
                                            )
                                          }
                                          disabled={!item.checked}
                                          className={`border ${
                                            isExceeding
                                              ? "border-red-500"
                                              : "border-gray-400"
                                          } rounded px-2 py-1 w-20`}
                                          max={item.remainingQuantity} // optional HTML restriction
                                        />
                                        {isExceeding && (
                                          <p className="text-red-500 text-xs mt-1">
                                            Quantity exceeds remaining (
                                            {item.remainingQuantity})
                                          </p>
                                        )}
                                      </td>

                                      <td className="px-6 py-4">
                                        {item.remainingQuantity}
                                      </td>
                                      <td className="px-6 py-4">
                                        {item.quantity_available_istock}
                                      </td>
                                      <td className="px-6 py-4">
                                        {item.cost_price}
                                      </td>
                                      <td className="px-6 py-4">
                                        {itemAmount}
                                      </td>
                                      <td className="px-6 py-4">
                                        {taxableAmount}
                                      </td>
                                      <td className="px-6 py-4">
                                        {item.hsn_code}
                                      </td>
                                      <td className="px-6 py-4">
                                        {item.sac_code}
                                      </td>
                                      <td className="px-6 py-4">
                                        {item.sgst_percentage}
                                      </td>
                                      <td className="px-6 py-4">
                                        {item.cgst_percentage}
                                      </td>
                                      <td className="px-6 py-4">
                                        {item.igst_percentage}
                                      </td>
                                      <td className="px-6 py-4">
                                        {sgstAmount}
                                      </td>
                                      <td className="px-6 py-4">
                                        {cgstAmount}
                                      </td>
                                      <td className="px-6 py-4">
                                        {igstAmount}
                                      </td>
                                      <td className="px-6 py-4">{totalTax}</td>

                                      <td className="px-6 py-4">
                                        <input
                                          className="bg-white-A700 border border-gray-400_02 border-solid h-9 rounded-[5px] w-full"
                                          type="text"
                                          value={item.item_description}
                                          onChange={(e) =>
                                            handleDescriptionChange(
                                              item.id,
                                              e.target.value
                                            )
                                          }
                                          disabled={!item.checked}
                                        />
                                      </td>
                                    </tr>
                                  );
                                })}
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </form>
          </Modal>
        </div>
      ) : (
        <div className="flex justify-center items-center h-screen">
          <div className="text-4xl text-red-500">No Access</div>
        </div>
      )}
    </div>
  );
};

export default DeliveryChallanItemJobWork;
